import { Link } from 'react-router-dom';
import { SemanticIcon } from './SemanticIcon';

interface OpenPenPalMarkProps {
  href?: string;
  compact?: boolean;
  className?: string;
}

/** Product-owned mark: a letter, a route, and one small point of connection. */
export function OpenPenPalMark({ href = '/', compact = false, className = '' }: OpenPenPalMarkProps) {
  const content = (
    <span className={`opp-brand-mark ${compact ? 'opp-brand-mark--compact' : ''} ${className}`.trim()}>
      <span className="opp-brand-mark__icon" aria-hidden="true">
        <SemanticIcon name="brand-mark" size={compact ? 22 : 26} />
      </span>
      {!compact && <span className="opp-brand-mark__word">OpenPenPal</span>}
    </span>
  );

  return href ? <Link to={href} aria-label="OpenPenPal 首页">{content}</Link> : content;
}

export default OpenPenPalMark;
